import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { findReport } from '@/features/reports/catalogue';
import { ReportPage } from '@/features/reports/report-page';
import { parseSettings, type Settings } from '@/features/reports/settings';

export const Route = createFileRoute('/accounting/audit-log')({
  component: AuditLog,
  validateSearch: (s: Record<string, unknown>): Settings => parseSettings(s),
});

/** Screen A6 (document 06): the audit log, which is also the Audit log report. */
function AuditLog() {
  const settings = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  return (
    <ReportPage
      spec={findReport('audit-log')!}
      settings={settings}
      onRun={(next) => void navigate({ search: next })}
    />
  );
}
